import { NgModule } from '@angular/core';
import { RRBootstrapModule } from '../bootstrap/bootstrap.module';
import { RRSharedModule } from '../shared-module/shared.module';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';

@NgModule({
  declarations: [ModalHeaderComponent],
  imports: [RRSharedModule, RRBootstrapModule],
  exports: [ModalHeaderComponent],
})
export class RRModalComponentsModule {}
